import { create } from "zustand";
import { CommonSlice, createCommonSlice } from "./common.slice";
import { ModalSlice, createModalSlice } from "./modal.slice";
import { RecallSlice, createRecallSlice } from "./recall.slice";
import { SearchSlice, createSearchSlice } from "./search.slice";
import { TranslationSlice, createTranslationSlice } from "./translation.slice";
import { WarehousesSlice, createWarehousesSlice } from "./warehouses.slice";

export const useStore = create<
  ModalSlice &
    SearchSlice &
    TranslationSlice &
    WarehousesSlice &
    CommonSlice &
    RecallSlice
>()((...a) => ({
  ...createModalSlice(...a),
  ...createSearchSlice(...a),
  ...createTranslationSlice(...a),
  ...createWarehousesSlice(...a),
  ...createCommonSlice(...a),
  ...createRecallSlice(...a),
}));
